import React, { Component } from 'react';

import { navigate } from '@reach/router';

import { IAdminClubActions } from '../../../../store/admin/clubs/actions';
import { ISeasonsActions } from '../../../../store/seasons/actions';

import Button from '../../../../components/Button';

interface IProps {
  actions: { adminClubs: IAdminClubActions; seasons: ISeasonsActions };
  clubId: number;
}

class CreationComplete extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  public async componentWillMount(): Promise<any> {
    const response = await this.props.actions.adminClubs.get(this.props.clubId);

    if (response.errors && response.errors.adminClubs) {
      setTimeout(navigate.bind(this, `/staff/club/create/info`));
    }
  }

  public onCancel = (): void => {
    navigate(`/login`);
  };

  public onSubmit = (): void => {
    const { clubId } = this.props;
    this.props.actions.seasons.get(Number(clubId), true, true).catch();

    navigate(`/staff/club/${clubId}/club-settings`);
  };

  public render(): JSX.Element {
    return (
      <div className="creation-complete form override">
        <h1 className="creation-complete__title override">SUCCESS!</h1>
        <p className="help-text creation-complete__text">
          Your club account has been succesfully created.
        </p>
        <p className="help-text creation-complete__text override">
          The next step is to add more info about the club for the players. Head over to club
          settings to upload a club logo, provide details about the club, and set any club dues.
        </p>
        <Button
          onClick={this.onSubmit}
          variant="contained"
          color="primary"
          type="submit"
          className="creation-complete__next-button button--shadow"
          size="large"
        >
          GO TO CLUB SETTINGS
        </Button>
      </div>
    );
  }
}

export { CreationComplete };
